<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import attributeList from "./attribute-list";
export default {
  components: { Layout, PageHeader, attributeList },
  data() {
    return {};
  },
};
</script>

<template>
  <Layout>
    <attribute-list />
  </Layout>
</template>